import { PointerSensor, TouchSensor } from "@dnd-kit/core";

import { TOUCH_SENSOR_CONFIG, POINTER_SENSOR_CONFIG } from "./constants";

export const getPlatformSensor = () =>
  "ontouchstart" in window ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0
    ? [TouchSensor, TOUCH_SENSOR_CONFIG]
    : [PointerSensor, POINTER_SENSOR_CONFIG];
